import MayLike from './MayLike'

export default MayLike
